import { FC } from 'react';
import dayjs from 'dayjs';
import { formatTeacherName } from 'shared/lib';

import { IGroupExamsRowTableScheduleProps } from '../models/types';

import styles from './styles.module.scss';

export const GroupExamsRowTableSchedule: FC<
  IGroupExamsRowTableScheduleProps
> = ({ data }) => {
  const localeDate = dayjs(data.examdate, 'DD.MM.YYYY')
    .locale('ru')
    .format('D MMMM, dd');

  return (
    <div className={styles['table-schedule-row']}>
      <div className={styles['table-schedule-cell']}>
        <div className={styles['table-schedule__date']}>
          <div className={styles['table-schedule__date-1']}>{localeDate}</div>
          <div className={styles['table-schedule__date-2']}>
            {data.examdate}
          </div>
        </div>
      </div>
      <div className={styles['table-schedule-cell']}>
        <div className={styles['table-schedule__time']}>{data.examtime}</div>
      </div>
      <div className={styles['table-schedule-cell']}>{data.disciplname}</div>
      <div
        className={styles['table-schedule-cell']}
      >{`${data.auditory} — ${data.building} здание`}</div>
      <div className={styles['table-schedule-cell']}>
        <div className={styles['table-schedule__teacher']}>
          {formatTeacherName(data.prepodfio)}
        </div>
      </div>
    </div>
  );
};
